import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["datesName", "isCurrentName", "onChange"];
import { useField } from "formik";
import React, { useCallback } from "react";
import { fromSerializedDate, toSerializedDate } from "../../../helpers";
import { DateRangeWithCurrent as DateRangeWithCurrentControl } from "../daterange-with-current";
export var DateRangeWithCurrent = function DateRangeWithCurrent(_ref) {
  var _datesField$value;

  var _ref$datesName = _ref.datesName,
      datesName = _ref$datesName === void 0 ? "date_range" : _ref$datesName,
      _ref$isCurrentName = _ref.isCurrentName,
      isCurrentName = _ref$isCurrentName === void 0 ? "is_current" : _ref$isCurrentName,
      onChangeProp = _ref.onChange,
      props = _objectWithoutProperties(_ref, _excluded);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  var _useField = useField(datesName),
      _useField2 = _slicedToArray(_useField, 3),
      datesField = _useField2[0],
      _datesMeta = _useField2[1],
      datesHelpers = _useField2[2]; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  var _useField3 = useField(isCurrentName),
      _useField4 = _slicedToArray(_useField3, 3),
      isCurrentField = _useField4[0],
      _isCurrentMeta = _useField4[1],
      isCurrentHelpers = _useField4[2];

  var onChange = useCallback(function (_ref2) {
    var dates = _ref2.dates,
        isCurrent = _ref2.isCurrent;
    var isCurrentValue = isCurrentField.value;
    var datesValue = datesField.value;
    var serializedDates = dates === null || dates === void 0 ? void 0 : dates.map(toSerializedDate);
    var changed = false;

    if (isCurrent !== isCurrentValue) {
      // isCurrentMeta.touched = true
      // isCurrentField.onChange(composeEventWithValue(isCurrent))
      isCurrentHelpers.setValue(isCurrent);
      changed = true;
    }

    if ((serializedDates === null || serializedDates === void 0 ? void 0 : serializedDates[0]) !== (datesValue === null || datesValue === void 0 ? void 0 : datesValue[0]) || (serializedDates === null || serializedDates === void 0 ? void 0 : serializedDates[1]) !== (datesValue === null || datesValue === void 0 ? void 0 : datesValue[1])) {
      // datesMeta.touched = true
      var serializedValue = dates.map(toSerializedDate); // datesField.onChange(composeEventWithValue(serializedValue))

      datesHelpers.setValue(serializedValue);
      changed = true;
    }

    if (!changed) return;

    if (onChangeProp) {
      onChangeProp({
        dates: dates,
        isCurrent: isCurrent
      });
    }
  }, [datesField, datesHelpers, isCurrentField, isCurrentHelpers, onChangeProp]);
  var date_range = (_datesField$value = datesField.value) !== null && _datesField$value !== void 0 ? _datesField$value : [];
  var parsedDates = date_range.map(fromSerializedDate);
  var startDate = parsedDates[0];
  var endDate = parsedDates[1];
  var isCurrent = isCurrentField.value;
  return /*#__PURE__*/React.createElement(DateRangeWithCurrentControl, _extends({}, props, {
    startDate: startDate,
    endDate: endDate,
    is_current: isCurrent,
    onChange: onChange
  }));
};